import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalEditorInfo } from 'src/app/modules/patterns/store/global-editor.selectors';

@Component({
    selector: 'app-global-editor-layout',
    templateUrl: './global-editor-layout.component.html',
    styleUrls: ['./global-editor-layout.component.scss']
})
export class GlobalEditorLayoutComponent {
    @Input() globalEditorInfo!: GlobalEditorInfo;
    @Output() showChange = new EventEmitter<boolean>();

    private _show = false;
    @Input() set show(value: boolean) {
        this._show = value;
        setTimeout(() => {
            this.showHideFromInside = value;
            this.showChange.emit(value);
        }, 0);
    }
    get show(): boolean {
        return this._show;
    }

    showHideFromInside = false;

    onToggle() {
        this.showHideFromInside = !this.showHideFromInside;
        this.showChange.emit(this.showHideFromInside);
    }
}
